import type { AxiosRequestConfig } from 'axios'

export function isApi3(requestConfig: AxiosRequestConfig) {
  return !!requestConfig.url?.includes('/v3')
}
